/* src/app/components/auth-usage-charts/spending-plan/spending-dashboard-help/spending-dashboard-help.component.css */
.help {
  font-size: 14px;
  line-height: 1.55;
  max-width: 760px;
}
.help p {
  margin: 0 0 8px;
}
.help-intro {
  font-size: 15px;
}
.help-part {
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid rgba(128, 128, 128, 0.25);
}
.help-part-title {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 0 4px;
  font-size: 18px;
  font-weight: 600;
}
.help-part-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #3d0072;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
}
.help h4 {
  margin: 16px 0 6px;
  font-size: 15px;
  font-weight: 600;
}
.help ul {
  margin: 0 0 8px;
  padding-left: 22px;
}
.help-callout {
  margin: 8px 0;
  padding: 10px 12px;
  border-left: 3px solid #3d0072;
  border-radius: 4px;
  background: rgba(61, 0, 114, 0.06);
}
.help-tip {
  border-left-color: #1abbb4;
  background: rgba(26, 187, 180, 0.08);
}
.help-terms {
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 6px 16px;
  margin: 0 0 8px;
}
.help-terms dt {
  font-weight: 600;
}
.help-terms dd {
  margin: 0;
}
@media (max-width: 600px) {
  .help-terms {
    grid-template-columns: 1fr;
    gap: 2px;
  }
  .help-terms dd {
    margin-bottom: 6px;
  }
}
/*# sourceMappingURL=spending-dashboard-help.component-TV36IZJ3.css.map */
